<template>
  <div>
    <div class="title-div">燃气户号管理</div>
    <div class="body-div" v-loading="loading">
      <div v-for="(item, index) in userGasList" :key="index" class="card-div" @click="toService(item)">
        <div class="row-div top-div">
          <div class="top-left-cell">
            <img src="../../../assets/pc/accountNumberManagement/gas.png">
          </div>
          <div class="top-center-cell">
            {{item.label}}
          </div>
          <div class="top-right-cell">
            <img src="../../../assets/pc/accountNumberManagement/delete.png" @click.stop="toDelete(item)">
          </div>
        </div>
        <el-divider class="divider-style"></el-divider>
        <div class="bottom-div">
          <div class="row-div">
            <div class="left-cell">用户编号：</div>
            <div class="right-cell">{{item.userCode}}</div>
          </div>
          <div class="row-div middle-div">
            <div class="left-cell">表型：</div>
            <div class="right-cell">{{item.meterType == 'C' ? '卡表' : item.meterType == 'R' ? '普表' : item.meterType ==
              'NB' ? '智能表' : item.meterType}}
            </div>
          </div>
          <div class="row-div">
            <div class="left-cell">地址：</div>
            <div class="right-cell">{{item.address}}</div>
          </div>
        </div>
      </div>
      <div v-if="userGasList.length < code" class="card-div add-card" @click="toAddAccountNumber()">
        <img src="../../../assets/pc/accountNumberManagement/add.png">
        <div class="add-div">添加新用户编号</div>
      </div>
    </div>
    <el-dialog
      title="取消户号"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div class="tip-div">该操作将在列表中删除用户！</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" class="cancel-button">取 消</el-button>
        <el-button type="primary" @click="onDeleteConfirm()" class="confirm-button">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getUserGasList, unbindUserGas } from '../../../api/accountNumberManagement'

  export default {
    name: 'PCAccountNumberManagement',
    data () {
      return {
        centerDialogVisible: false, // 是否显示取消户号对话框
        loading: false, // 是否显示加载提示
        code: '', // 可以绑定的户号数
        userGasList: [], // 户号列表
        toDeleteUserCode: {} // 要删除的户号
      }
    },
    mounted () {
      if (this.$route.query.title) {
        window.localStorage.pageTitle = this.$route.query.title
      }
      if (window.localStorage.token) {
        this.getUserGasList()
      } else {
        this.$router.push('/pcLogin')
      }
    },
    methods: {
      // 添加新用户编号
      toAddAccountNumber () {
        this.$router.push('/pcGasAccountManagement1')
      },

      // 跳转到燃气服务页面
      toService (val) {
        /*this.$router.push({
          name: 'PCService'
        })*/
        if (window.localStorage.pageTitle == '查询') {
          this.$router.push('/pcGasAccountInfo')
        } else if (window.localStorage.pageTitle == '发票') {
          if (val.meterType == 'R') {
            this.$router.push('/pcGasInvoice')
          } else {
            this.$message({
              message: '开票只支持普表',
              type: 'warning',
              offset: 200
            });
          }
        } else {
          this.$router.push('/pcGasRepair')
        }
        this.$store.commit('setCardObj', val)
      },

      // 获取用户绑定的燃气号列表
      getUserGasList () {
        const that = this
        that.loading = true
        const params = {
          userId: window.localStorage.userId
        }
        getUserGasList(params).then(res => {
          if (res.data.success) {
            that.code = res.data.code
            that.userGasList = res.data.rows
            that.loading = false
          } else {
            that.loading = false
            that.$message.error(res.data.message)
          }
        }).catch(() => {
          that.$message.error('登录已过期，请重新登录')
          this.$router.push('/pcLogin')
        })
      },

      // 删除户号
      toDelete (item) {
        this.toDeleteUserCode = item
        this.centerDialogVisible = true
      },

      // 确认删除户号
      onDeleteConfirm() {
        const that = this
        that.centerDialogVisible = false
        const params = {
          id: that.toDeleteUserCode.id
        }
        unbindUserGas(params).then(res => {
          if (res.data.success) {
            that.$message({
              message: res.data.message,
              type: 'success'
            });
            that.getUserGasList();
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(() => {
          that.$message.error('取消户号失败');
        })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .row-div {
    display: flex;
  }

  .left-cell {
    width: 24%;
    text-align: right;
    padding-right: 18%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #62667A;
  }

  .right-cell {
    width: 58%;
    text-align: right;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #000000;
  }

  .card-div {
    width: 48%;
    box-shadow: 0px 2px 4px 4px rgba(215, 215, 215, 0.5);
    border-radius: 2px;
    border: 1px solid #DCDFE6;
    margin-bottom: 30px;
  }

  .divider-style {
    margin: 0;
  }

  .top-left-cell {
    width: 10%;
  }

  .top-center-cell {
    width: 40%;
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .top-right-cell {
    width: 50%;
    text-align: right;
  }

  .top-div {
    padding: 14px 6% 11px 5%;
    align-items: center;
  }

  .bottom-div {
    padding: 19px 9% 36px 11%;
  }

  .middle-div {
    margin: 20px 0;
  }

  .body-div {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 45px 21% 80px 21%;
  }

  .add-card {
    text-align: center;
    padding-top: 66px;
    padding-bottom: 85px;
  }

  .add-div {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #62667A;
    margin-top: 10px;
  }

  /deep/ .el-dialog__title {
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .tip-div {
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
  }

  .cancel-button {
    width: 80px;
    height: 36px;
    background: #F0F2F5;
    border: 1px solid #D7DBE0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    padding: 0;
    border-radius: 0;
  }

  .el-button:focus, .el-button:hover {
    color: #333333;
    border-color: #D7DBE0;
    background-color: #F0F2F5;
  }

  .confirm-button {
    width: 80px;
    height: 36px;
    background: #BD1A2D;
    border: 1px solid #BD1A2D;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    border-radius: 0;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
    color: #FFF;
  }

  /deep/ .el-dialog--center {
    border-radius: 12px;
  }

  /deep/.el-dialog__headerbtn:focus .el-dialog__close, /deep/.el-dialog__headerbtn:hover .el-dialog__close {
    color: #BD1A2D;
  }
</style>
